module.exports = __webpack_public_path__ + "src/routes/home/Customization.png?6262e4e7";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/Customization.png
// module id = 915
// module chunks = 1